import { Action } from '@ngrx/store';
import { IUserParam} from '../../models/userparam.model';

export enum UserParamActionType {
    FETCH_USERPARAMS = '[UserParam] Fetch UserParams',
    ADD_USERPARAM = '[UserParam] Add UserParam',
    SET_USERPARAM_TO_COMPLETE = '[UserParam] Set UserParam To Complete',
    DELETE_USERPARAM = '[UserParam] Delete UserParam',
}

export class FetchUserParamAction implements Action {
    readonly type = UserParamActionType.FETCH_USERPARAMS;
    constructor(public userParams: IUserParam[]) {
        console.log("FetchUserParamAction: ", JSON.stringify(userParams));  
     }
}

export class AddUserParamAction implements Action {
    readonly type = UserParamActionType.ADD_USERPARAM
    constructor(public userParam: IUserParam) {
        console.log("in AddUserParamAction:" + JSON.stringify(userParam));
     }
}

export class SetUserParamToCompleteAction implements Action {
    readonly type = UserParamActionType.SET_USERPARAM_TO_COMPLETE;
    constructor(public id: number) { }
}

export class DeleteUserParamAction implements Action {
    readonly type = UserParamActionType.DELETE_USERPARAM;
    constructor(public id: number) { }
}

export type UserParamAction = FetchUserParamAction
    | AddUserParamAction
    | SetUserParamToCompleteAction
    | DeleteUserParamAction;